import { useEffect } from 'react';

/**
 * Hook to load and initialize Metricool tracking pixel
 * Deferred to avoid blocking main thread during initial load
 */
export function useMetricoolTracking() {
  useEffect(() => {
    // Check if script already exists to avoid duplicates
    if (document.querySelector('script[src="https://tracker.metricool.com/resources/be.js"]')) {
      return;
    }

    const loadTracking = () => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://tracker.metricool.com/resources/be.js";
      script.async = true;
      script.onload = () => {
        const win = window as Window & { beTracker?: { t: (config: { hash: string }) => void } };
        if (win.beTracker) {
          win.beTracker.t({ hash: "e8019c94176667b928d7de356f417a88" });
        }
      };
      document.head.appendChild(script);
    };

    // Defer loading until browser is idle or after 3s timeout
    if ('requestIdleCallback' in window) {
      (window as Window & { requestIdleCallback: (cb: () => void, opts?: { timeout: number }) => void })
        .requestIdleCallback(loadTracking, { timeout: 3000 });
    } else {
      setTimeout(loadTracking, 2000);
    }
  }, []);
}
